import {Chip} from "@mui/material";

export type PillTone = "openOrange" | "doneGreen" | "neutral";

export const pillColors: Record<PillTone, { bg: string; fg: string }> = {
    openOrange: { bg: "#F25C2A", fg: "#FFFFFF" }, // laranja (Em aberto)
    doneGreen:  { bg: "#18B77E", fg: "#FFFFFF" }, // verde (Finalizado)
    neutral:    { bg: "#EEF1F6", fg: "#3A4657" }, // fallback
};

export function Pill({ label, tone }: { label: string; tone: PillTone }) {
    const c = pillColors[tone];

    return (
        <Chip
            label={label}
            size="small"
            sx={{
                height: 24,
                borderRadius: 999,
                bgcolor: c.bg,
                color: c.fg,
                fontWeight: 500,
                fontSize: 12,
                "& .MuiChip-label": {
                    px: 1.25,
                    py: 0,
                },
            }}
        />
    );
}